import React from 'react'
import './styles/Clientes.css'
import { withTranslation } from 'react-i18next';
import { MDBCol, MDBContainer, MDBRow } from 'mdbreact'
// import MH from '../archivos/logos/logo_mindhub.png'
// import Murchison from '../archivos/logos/logo_murchison-rem.png'
// import Newsan from '../archivos/logos/logo_newsan.png'
// import EY from '../archivos/logos/logo_ey.png'
// import Wemfi from '../archivos/logos/logo-wemfi.png'
import Carrausel from './CustomerCarrousel';
import CasosDeExito from './CasosDeExito';
class Clientes extends React.Component {

    constructor() {
        super()
        this.state = {
            info: []


        }

    }

    render() {
        const { t, i18n } = this.props
        return (
            <div id="Clientes" className="containClientes">
                <h1 className="Clientesh1">{t('clientes.h1')}</h1>
                <MDBRow style={{ width: '100%', padding: '2vh 0%', margin: "0" }}>
                    {/* <MDBCol md="4" style={{ marginBottom: '35px' }}>
                        <img src={MH} style={{ width: '45%', display: 'block', margin: 'auto', minHeight: 50 }} alt="Imagen" />
                    </MDBCol>
                    <MDBCol md="3" style={{marginBottom: '35px', display:'flex',  alignItems: 'center'}} >
                        <img src={Murchison}  style={{width: '50%', display: 'block', margin: 'auto',}}/>
                    </MDBCol>
                    <MDBCol md="4" style={{ marginBottom: '35px', display: 'flex', alignItems: 'center' }} >
                        <img src={Wemfi} style={{ width: '50%', display: 'block', margin: 'auto', }} alt="Imagen" />
                    </MDBCol>
                    <MDBCol md="4" style={{ marginBottom: '35px', display: 'flex', alignItems: 'center' }}>
                        <img src={Newsan} style={{ width: '50%', display: 'block', margin: 'auto', }} alt="Imagen" />
                    </MDBCol>
                    <MDBCol md="3" style={{marginBottom: '35px'}}>
                        <img src={EY}  style={{width: '45%', display: 'block', margin: 'auto', minHeight:50}}/>
                    </MDBCol> */}
                    <div className="swiperContainer">
                        <Carrausel />
                    </div>
                </MDBRow>
                <CasosDeExito />
            </div>
        )
    }
}
export default withTranslation()(Clientes)